import Dashboard from '../pages/Index.vue';
import Page from '../../GeneralViews/Page.vue';

export default [
  {
    path: '/dashboard',
    component: Page,
    children: [
      {
        path: '',
        name: 'Dashboard',
        component: Dashboard,
      },
    ],
    meta: { requiresAuth: true },
  },
];
